import { template } from 'lodash';

/**
 * Generates a string by replacing variables in a template string.
 *
 * @param templateString The template string containing variables in the format {{{variable}}}.
 * @param params An object with key-value pairs to replace the variables in the template.
 * @returns The generated message with variables replaced.
 */
export const generateTemplate = (
  templateString: string,
  params: { [key: string]: string | number },
): string => {
  const compileTemplate = template(templateString, {
    interpolate: /{{{([\s\S]+?)}}}/g,
  });

  return compileTemplate(params);
};

export const generateMessage = generateTemplate;
